export default __webpack_public_path__ + "static/purple-triangle-edges-78f343e5ee6a394cbbfb94849e545d98.jpg";